var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTruckBan = function SvgTruckBan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.5 16.472a6.472 6.472 0 1 0 0-12.944 6.472 6.472 0 0 0 0 12.944"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5358",
    d: "M11.383 13.067a.868.868 0 1 1 0-1.737c.478 0 .872.39.872.871a.87.87 0 0 1-.872.866M13.95 7.544H6.078v3.618h7.872zM12.43 12.2h.412l1.108-.43v-.445h-1.996c.284.189.475.512.475.875"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5358",
    d: "M5.895 11.323V8.471H3.77a.27.27 0 0 0-.25.174l-.622 1.688a.3.3 0 0 0-.016.092v1.505c0 .148.12.267.267.267h.199c0-.573.472-1.051 1.051-1.051.58 0 1.053.478 1.049 1.051h4.878c0-.356.188-.678.472-.874zm-.908-.94H3.359a.09.09 0 0 1-.085-.122l.513-1.416a.09.09 0 0 1 .085-.06h1.115c.05 0 .09.04.09.09v1.418c0 .05-.04.091-.09.09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5358",
    d: "M4.4 13.073a.875.875 0 0 1 0-1.749.875.875 0 0 1 0 1.749"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CF1322",
    d: "M15.871 6.886a8 8 0 0 0-1.714-2.543A7.97 7.97 0 0 0 8.5 2a7.971 7.971 0 0 0-5.657 2.343A7.97 7.97 0 0 0 .5 10a7.973 7.973 0 0 0 2.343 5.657A7.97 7.97 0 0 0 8.5 18a7.975 7.975 0 0 0 5.657-2.343A7.98 7.98 0 0 0 16.5 10a7.95 7.95 0 0 0-.629-3.114M8.5 16.453A6.46 6.46 0 0 1 2.047 10c0-1.57.564-3.012 1.5-4.132l9.085 9.085a6.42 6.42 0 0 1-4.132 1.5m4.953-2.321L4.368 5.047a6.42 6.42 0 0 1 4.132-1.5A6.46 6.46 0 0 1 14.953 10c0 1.57-.564 3.012-1.5 4.132"
  })));
};
export default SvgTruckBan;